import { Directive, effect, input, signal } from '@angular/core'

import { fonts, theme } from '@flowx/core-sdk'
import { TabBarStyles, applyTabBarCustomStyles } from '@flowx/core-theme'

@Directive({
  selector: 'flx-tab-bar',
  standalone: true,
  host: {
    '[class]': 'styleClassName()',
  },
})
export class FlxTabBarStyleDirective {
  componentStyle = input<{
    style: TabBarStyles
  }>()

  styleClassName = signal<string>('')

  constructor() {
    effect(async () => {
      const className = await applyTabBarCustomStyles(this.componentStyle().style, theme(), fonts())
      this.styleClassName.set(className)
    })
  }
}
